<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Item Name</label>
                  <div class="row">
                    <b-form-input type="text" v-model="form.itemname"  ref="itemNameInput" @keypress.enter="submitForm()"/>
                    </div>
                </div>
              </div>

               <div class="col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <b-form-textarea
                    id="textarea"
                    v-model="form.itemdescription"
                    rows="3"
                    max-rows="6"
                    @keypress.enter="submitForm()"
                  ></b-form-textarea>
                </div>
              </div>
              
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Category</label>
                  <div class="row">
                      <model-list-select
                        :list="categoryListFromApi"
                        v-model="form.itemcategory"
                        option-value="categoryid"
                        option-text="categoryname"
                        placeholder="Select category"
                      >
                      </model-list-select>
                    </div>
                    
                </div>
              </div>

              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Unit</label>
                  <b-form-input type="text"  v-model="form.unit" @keypress.enter="submitForm()"/>
                </div>
              </div>
              

              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>UnitPrice</label>
                  <b-form-input type="number"  v-model="form.unitprice" @keypress.enter="submitForm()"/>
                </div>
              </div>
              
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Available</label>
                  <b-form-input type="number"  v-model="form.available" @keypress.enter="submitForm()"/>
                </div>
              </div>
              
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Threshold</label>
                  <b-form-input type="number"  v-model="form.threshold" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Rack Number</label>
                  <b-form-input type="text"  v-model="form.rack_no" @keypress.enter="submitForm()"/>
                </div>
              </div>
               <!-- <div class="col-lg-12">
                <div class="form-group">
                  <label>Item Images (Optional - Max 4)</label>
                  <input 
                    type="file" 
                    accept="image/*" 
                    multiple 
                    @change="handleImageUpload" 
                    ref="imageUploader" 
                    style="display: none;"
                  />
                  <div class="d-flex flex-wrap align-items-center">
                    <div v-for="(image, index) in localImages" :key="index" class="image-preview-container me-3 mb-3">
                      <img :src="image.url" class="img-thumbnail" alt="Item Image" style="width: 100px; height: 100px; object-fit: cover;"/>
                      <span class="remove-image-icon" @click="removeLocalImage(index)">×</span>
                    </div>

                    <div 
                      class="add-image-placeholder me-3 mb-3" 
                      @click="$refs.imageUploader.click()"
                      v-if="localImages.length < maxImages"
                    >
                      <i class="fas fa-plus"></i>
                      <span>Add Image</span>
                    </div>

                    <div v-if="localImages.length === maxImages" class="text-muted small">
                      (Maximum 4 images selected)
                    </div>
                  </div>
                  <small v-if="uploadError" class="text-danger">{{ uploadError }}</small>
                </div>
              </div> -->
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="productlist" class="btn btn-cancel">Cancel</router-link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ModelListSelect } from "vue-search-select"
import axios from "axios";
import { mapGetters } from 'vuex';

async function ImageUploadApi(item_id, files) {
    const formData = new FormData();
    formData.append('item_id', item_id);
    files.forEach(file => {
        formData.append('image_files', file); 
    });
    
    const response = await axios.post(`/v1/items/${item_id}/images`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}

export default {
  data() {
    return {
      form: {
        itemname: '',
        itemdescription: '',
        itemcategory: '',
        categoryid:'',
        unit: '',
        unitprice:'0',
        available: '0',
        threshold: '0',
        locationid:'',
        rack_no:'',
      },
      title: "Add Item",
      title1: "Create new item",
      categoryListFromApi: [],
      localImages: [], 
      maxImages: 4,
      uploadError: '',
    };
  },
  created(){
    this.fetchCategoryListFromApi();
  },
  mounted() {
    this.$refs.itemNameInput.focus();
  },
  computed:{
    ...mapGetters(['getCurrentLocation']),

    currentLocation() { return this.getCurrentLocation; },
    
    locationName() {
      const loc = this.currentLocation;
      return loc ? Object.keys(loc) : null;
    },
    locationId() {
      const loc = this.currentLocation;
      return loc ? loc.id: null;
    },
  },
  methods: {
    handleImageUpload(event) {
      const files = event.target.files;
      this.uploadError = '';
      if (!files.length) return;

      const currentCount = this.localImages.length;
      const spaceLeft = this.maxImages - currentCount;
      const filesToAdd = Array.from(files).slice(0, spaceLeft);

      if (filesToAdd.length < files.length) {
          this.uploadError = `You can only select up to ${this.maxImages} images. Only the first ${filesToAdd.length} were added.`;
      }
      
      filesToAdd.forEach(file => {
          if (file.type.startsWith('image/')) {
              // Create local URL for preview
              const fileURL = URL.createObjectURL(file);
              this.localImages.push({
                  file: file,
                  url: fileURL
              });
          } else {
              this.uploadError = 'Only image files are allowed.';
          }
      });

      // Reset the file input value to allow the same file(s) to be selected again
      event.target.value = null; 
    },

    removeLocalImage(index) {
        // Revoke the local URL to free up memory
        URL.revokeObjectURL(this.localImages[index].url);
        this.localImages.splice(index, 1);
        // Clear error if images are removed
        if (this.localImages.length < this.maxImages) {
             this.uploadError = '';
        }
    },

    async uploadImages(itemId) {
        if (this.localImages.length === 0) {
            console.log('No images to upload.');
            return;
        }
        const filesToUpload = this.localImages.map(img => img.file);
        try {
            const response = await ImageUploadApi(itemId, filesToUpload); 
            console.log("Image Upload Success:", response);
        } catch (error) {
            console.error('Image Upload Error:', error);
            Swal.fire({
                title: 'Item Created, but Image Upload Failed',
                text: 'The item was added successfully, but there was an error uploading the images. Please try editing the item to add images later.',
                icon: 'warning',
            });
        }
    },

    async fetchCategoryListFromApi() {
    try {
      const response = await axios.get(`/v1/category?locationid=${this.locationId}`);
      this.categoryListFromApi = response.data; 
    } catch (error) {
      console.error('Error fetching category list:', error);
      }
    },

    postData() {
      if (!this.form.itemname) {
        Swal.fire("Please enter the item name");
        return;
      }

      if (!this.form.itemcategory) {
        Swal.fire("Please select a category");
        return;
      }
      this.form.locationid = this.locationId
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      }).then(async (result) => { 
        if (result.isConfirmed) {
          try {
            const itemResponse = await axios.post('/v1/items', this.form);
            const newItemId = itemResponse.data.itemid; 
            if (this.localImages.length > 0) {
                await this.uploadImages(newItemId);
            }
            Swal.fire("Item created successfully" + (this.localImages.length > 0 ? " and images uploaded." : "."));
            this.$router.push({ path: '/productlist' });

          } catch (error) {
            console.log(error);
            const errorMessage = error.response ? error.response.data.detail : error.message;
            Swal.fire(`Error creating item: ${errorMessage}`);
          }
        }
      });
    },
    submitForm() {
      this.postData();
    }
  },
  components: {
    ModelListSelect
  },
  name: "addproduct",
  // Lifecycle hook to clean up local URLs on component destruction
  beforeDestroy() {
    this.localImages.forEach(img => URL.revokeObjectURL(img.url));
  },
};
</script>

<style scoped>
/* Scoped styles for the image feature */
.image-preview-container {
    position: relative;
    display: inline-block;
}

.remove-image-icon {
    position: absolute;
    top: -5px;
    right: -5px;
    background: red;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;
    padding: 0;
}

.add-image-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    border: 2px dashed #ccc;
    border-radius: 5px;
    cursor: pointer;
    color: #6c757d;
    transition: all 0.2s;
}

.add-image-placeholder:hover {
    border-color: #007bff;
    color: #007bff;
}

.add-image-placeholder i {
    font-size: 24px;
    margin-bottom: 5px;
}
</style>